import {AuthService} from 'modules/auth/services/AuthService';
import {LocationService} from 'modules/locations/services/LocationService';
import {CookieService} from 'core/services/CookieService';
import {isBrowserContext} from 'core/helpers';

export const extraArgs = {
    // articlesService: new ArticlesService(),
    authService: new AuthService(),
    // calculatorService: new CalculatorService(),
    // cartService: new CartService(),
    cookieService: CookieService.getInstance(),
    locationService: new LocationService(),
    navigator: isBrowserContext() && 'undefined' !== typeof navigator && navigator,
    // productCardService: new ProductCardService(),
    // productSubscriptionService: new ProductSubscriptionService(),
    // productsService: new ProductsService(),
    // verificationService: new VerificationService(),
    // wishListService: new WishListService(),
};

export type TAppExtraArgs = typeof extraArgs;
